/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import s from"./Dictionary.js";class t extends s{constructor(s){super(),this.declaredClass="esri.arcade.Portal",this.immutable=!1,this.setField("url",s),this.immutable=!0}}export{t as default};
